import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { ManageReceiptTemplatesRootParamList } from "../../../../types";
import { useLoadMoreList } from "../../../../utilities/load-more-list";
import { Receipt } from "@towersystems/roam-common/lib/generated-types";
import { QUERY_LIST_RECEIPT_TEMPLATES } from "../../common";
import { useFocusEffect } from "@react-navigation/native";
import React from "react";
import {
  Button,
  Divider,
  FlatActionList,
  FlatListSearchable,
  Page,
  View,
} from "@towersystems/roam-common-native";
import { FlatListSearchableSkeleton } from "../../../../components/FlatListSearchableSkeleton";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";

export type ManageReceiptTemplatesScreenProps = NativeStackScreenProps<
  ManageReceiptTemplatesRootParamList,
  "ManageReceiptTemplatesScreen"
>;

export const ManageReceiptTemplatesScreen = ({
  navigation,
}: ManageReceiptTemplatesScreenProps) => {
  const transitionEnded = useHasTransitionEnded(navigation);

  React.useEffect(() => {
    navigation.setOptions({
      headerRight: ({}) => (
        <Button
          isAction
          size="compact"
          label="New receipt template"
          onPress={() =>
            navigation.navigate("CreateReceiptTemplateScreen", {
              screen: "ReceiptTemplateFormScreen",
            })
          }
        ></Button>
      ),
    });
  }, []);

  const loadMoreList = useLoadMoreList<Receipt>({
    initialLoad: false,
    query: QUERY_LIST_RECEIPT_TEMPLATES,
    resultKey: "receipts",
    sort: { updatedAt: "DESC" },

    variableFormatter: (variables) => {
      return {
        options: {
          ...variables,
          limit: 9999,
        },
      };
    },
  });

  useFocusEffect(
    // refresh the list when the screen is focused
    React.useCallback(() => {
      loadMoreList.loadMore(undefined, true);
    }, [])
  );

  const renderItem = React.useCallback(({ item }: { item: Receipt }) => {
    return (
      <FlatActionList.RenderItem
        item={{
          key: item.id,
          title: item.name,
          subTitle: item.defaultTemplateType,
          onPress: () => {
            navigation.navigate("EditReceiptTemplateScreen", {
              screen: "ReceiptTemplateFormScreen",
              receiptTemplateId: item.id,
            });
          },
        }}
      ></FlatActionList.RenderItem>
    );
  }, []);

  if (
    (loadMoreList.loading && loadMoreList.items.length == 0) ||
    !transitionEnded
  ) {
    return <FlatListSearchableSkeleton searchbar={false} />;
  }

  return (
    <Page
      title="Receipt templates"
      secondaryTitle="Manage your receipt templates"
      scrollable={true}
    >
      <FlatListSearchable
        renderSearchBarHeader={() => <View />}
        ItemSeparatorComponent={Divider}
        renderItem={renderItem}
        data={loadMoreList.items ?? []}
      />
    </Page>
  );
};
